import { getAsync as _getAsync, patchAsync as _patchAsync } from "../../api";

const BASE_URL = "/general/my-assignments";

export async function getAllAsync({ data }) {
    return _getAsync({ url: BASE_URL, data });
}

export async function changeFileCaseAssignee(module, fileCaseId, newAssigneeUserId, newDueDate, shouldSetNewDueDate = true) {
    return _patchAsync({
        url: `/modules/${module}/file-cases/${fileCaseId}:change-assignee`,
        data: { assigneeUserId: newAssigneeUserId, dueDate: newDueDate, shouldSetNewDueDate },
    });
}
